import type { CityConfig } from "../city-template/types";

export const dekalbConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Illinois Vital Records (Birth, Death, Marriage)", href: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", description: "Official Illinois Department of Public Health vital records office in Springfield" },
    { label: "DeKalb County Clerk — Birth, Death &amp; Marriage Records", href: "https://www.dekalbcounty.org/", description: "DeKalb County Clerk — local vital records and marriage licenses" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Illinois DPH for online vital record orders" },
  ],
  city: "DeKalb",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "dekalb",
  route: "/dekalb",
  title: "Emergency Passport DeKalb, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in DeKalb, Illinois — as fast as 24 hours. Fast passport renewal for NIU students, faculty, and all DeKalb County residents. A+ BBB rated registered State Dept. courier serving Northern Illinois University and the greater DeKalb area.",
  h1: "Emergency & Expedited Passport Services in DeKalb, IL",
  heroSubtitle: "Northern Illinois University study abroad acceptance letter just arrived and your passport's expired? NIU faculty with a last-minute international conference? Agricultural exporter heading to a trade show in three days? We help DeKalb residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving DeKalb County and Northern Illinois University.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=DeKalb%20Illinois%20Northern%20Illinois%20University%20campus%20with%20historic%20Altgeld%20Hall%20castle%20like%20architecture%20and%20tree%20lined%20pathways%2C%20the%20iconic%20East%20Lagoon%20reflecting%20autumn%20colors%2C%20downtown%20DeKalb%20with%20Lincoln%20Highway%20Route%2038%20storefronts%20and%20historic%20buildings%2C%20corn%20fields%20surrounding%20the%20city%20in%20golden%20sunset%20light%2C%20the%20Egyptian%20Theatre%20marquee%20on%20Main%20Street%2C%20college%20town%20atmosphere%20with%20students%20walking%20across%20campus%2C%20warm%20late%20afternoon%20light%20over%20the%20Kishwaukee%20River%20valley&width=1800&height=700&seq=dekalb-hero-001&orientation=landscape",
  heroImageAlt: "Northern Illinois University campus and downtown DeKalb Illinois at golden hour",
  geoPosition: "41.9295;-88.7504",
  geoPlacename: "DeKalb, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 1 hour 15 minutes east of DeKalb via I-88",
  },
  nearbyCitiesZips: [
    { name: "DeKalb", zips: "60115" },
    { name: "Sycamore", zips: "60178" },
    { name: "Cortland", zips: "60112" },
    { name: "Genoa", zips: "60135" },
    { name: "Malta", zips: "60150" },
    { name: "Hinckley", zips: "60520" },
    { name: "Waterman", zips: "60556" },
    { name: "Sandwich", zips: "60548" },
    { name: "Rochelle", zips: "61068" },
    { name: "Shabbona", zips: "60550" },
    { name: "Maple Park", zips: "60151" },
    { name: "Leland", zips: "60531" },
    { name: "Kingston", zips: "60145" },
    { name: "Kirkland", zips: "60146" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — just 75 minutes away via I-88, but you skip the trip" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for DeKalb County travelers" },
    { icon: "ri-graduation-cap-line", title: "NIU Student Hub", desc: "Serving Northern Illinois University students and faculty with study abroad and international academic travel needs" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Ship from UPS Store on Lincoln Highway or any FedEx in DeKalb — no Chicago drive required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Rockford, IL", route: "/rockford" },
    { name: "Urgent passport services in Elgin, IL", route: "/elgin-il" },
    { name: "Emergency passport help in Aurora, IL", route: "/aurora" },
    { name: "Illinois passport services overview", route: "/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves DeKalb, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (1 hour 15 minutes east via I-88) — without you making the trip. DeKalb residents can ship from UPS Store on Lincoln Highway or any FedEx location in DeKalb County. For NIU students and faculty, our courier service saves hours of driving and downtown Chicago parking headaches.",
  fpcOfficeDistance: "Serving DeKalb, Sycamore, Cortland, Genoa, Malta, Hinckley, Waterman, Sandwich, Rochelle, Shabbona, Maple Park, Leland, Kingston, Kirkland, and all of DeKalb County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout DeKalb and the entire DeKalb County region. From the NIU campus and Greek Row to the historic downtown Lincoln Highway corridor, from the agricultural communities to the residential neighborhoods — we serve the entire DeKalb-Sycamore area.",
  nearbyCitiesIntro: "We serve DeKalb and all nearby communities including Sycamore, Cortland, Genoa, Malta, Hinckley, Waterman, Sandwich, Rochelle, Shabbona, Maple Park, Leland, Kingston, and Kirkland.",
  howItWorksIntro: "Most DeKalb travelers complete everything online and ship documents overnight. No need to drive over an hour to Chicago — our couriers handle the Chicago Passport Agency trip for you. For NIU students with study abroad deadlines, this is the fastest practical option in DeKalb County.",
  mistakesIntro: "DeKalb is home to Northern Illinois University with a robust study abroad program, yet the nearest passport agency is over an hour away. Between students juggling finals and families planning agricultural trade trips, here are the most common passport mistakes in DeKalb County.",
  testimonialsIntro: "DeKalb travelers — from NIU students with study abroad acceptances and faculty heading to international conferences to agricultural trade professionals and DeKalb County families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in DeKalb, IL? Here are the most common ones we hear from NIU students, faculty, and DeKalb County residents.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No 2.5-hour round trip to Chicago required", "Perfect for NIU study abroad deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "2.5+ hour round trip drive to Chicago", "Impractical for most DeKalb County residents"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For DeKalb travelers with immediate departure needs — as fast as 24 hours. Essential for NIU study abroad deadlines and international academic conference travel.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "No Chicago round trip — ship locally from DeKalb"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for DeKalb adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your DeKalb address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for DeKalb residents — NIU freshmen preparing for study abroad, new citizens, and DeKalb County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for DeKalb residents who lost their passport before study abroad departure, conference travel, or family trips.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for DeKalb, Sycamore, and DeKalb County families traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for DeKalb and DeKalb County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized passport card for DeKalb residents who need land/sea travel to Canada or Mexico — ideal for quick North American trips.",
      bullets: ["Land and sea travel to Canada, Mexico, Caribbean", "Wallet-sized convenience", "REAL ID compliant"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Passport replacement for DeKalb residents with water-damaged, torn, or otherwise damaged passports that need urgent replacement.",
      bullets: ["DS-11 form with damage explanation", "Photo verification for identity matching", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Second valid passport book for DeKalb business travelers and NIU faculty who frequently travel internationally and need a backup while one is with an embassy.",
      bullets: ["Second valid passport book", "Ideal for frequent business travelers and faculty", "Keep traveling while visa processes"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport DeKalb IL", description: "Urgent passport processing for DeKalb Illinois travelers and NIU students with immediate departure needs." },
    { name: "Expedited Passport Renewal DeKalb IL", description: "Fast passport renewal for DeKalb Illinois residents and Northern Illinois University community members." },
    { name: "First-Time Passport DeKalb IL", description: "New passport application services for DeKalb Illinois residents." },
    { name: "Child Passport DeKalb IL", description: "Minor passport services for DeKalb Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Marcus T.",
      location: "DeKalb, IL — NIU Student",
      rating: 5,
      text: "NIU's semester abroad in Barcelona was confirmed and I had 7 days to renew my passport. Fast Passport Center got it done in 4 days — I shipped from the UPS on Lincoln Highway near campus. Made my flight and now I'm in Spain. Every Huskie planning to study abroad needs to know about this service.",
      service: "Passport Renewal",
    },
    {
      name: "Dr. Sarah K.",
      location: "DeKalb, IL — NIU Faculty",
      rating: 5,
      text: "Last-minute invitation to present at an international engineering conference in Tokyo and my passport was expiring in 2 months — way under the 6-month rule. Fast Passport Center renewed it in 3 days. The Chicago round trip would've killed a whole day of lecture prep. Faculty colleagues, this is the way.",
      service: "Passport Renewal",
    },
    {
      name: "The Peterson Family",
      location: "Sycamore, IL",
      rating: 5,
      text: "Planned a family trip to Ireland over winter break and discovered the kids' passports expired. Fast Passport Center helped with all 3 child passports — had them in 5 days. The DeKalb County Clerk's office was easy for the DS-11s. DeKalb County families, don't waste time driving to Chicago.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "dkb-1",
      name: "DeKalb Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "600 E Lincoln Hwy",
      city: "DeKalb",
      state: "IL",
      zip: "60115",
      phone: "(815) 756-6788",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "DeKalb, near downtown and NIU campus",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary DeKalb acceptance facility. Convenient to NIU campus and downtown DeKalb on Lincoln Highway. Walk-in availability subject to staffing — appointments recommended. Near the Egyptian Theatre and downtown shops.",
      icon: "ri-mail-line",
    },
    {
      id: "dkb-2",
      name: "DeKalb County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "110 E Sycamore St",
      city: "Sycamore",
      state: "IL",
      zip: "60178",
      phone: "(815) 895-7149",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Sycamore, approximately 4 miles east of DeKalb",
      website: "https://www.dekalbcounty.org/",
      websiteLabel: "DeKalb County Clerk",
      notes: "DeKalb County seat acceptance facility in Sycamore. Historic courthouse square setting. Often less crowded than post office locations. Good for county residents in Sycamore and eastern DeKalb County. Call ahead to confirm passport hours.",
      icon: "ri-government-line",
    },
    {
      id: "dkb-3",
      name: "Sycamore Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1040 E State St",
      city: "Sycamore",
      state: "IL",
      zip: "60178",
      phone: "(815) 895-5122",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Sycamore, approximately 4 miles east of DeKalb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Sycamore and eastern DeKalb communities. Good alternative when DeKalb post office is busy. Near Sycamore downtown and county facilities.",
      icon: "ri-mail-line",
    },
    {
      id: "dkb-4",
      name: "Rochelle Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "501 Lincoln Hwy",
      city: "Rochelle",
      state: "IL",
      zip: "61068",
      phone: "(815) 562-7141",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Rochelle, approximately 15 miles west of DeKalb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Rochelle and western DeKalb County. Hub city with the Union Pacific Railroad intersection — convenient for Ogle County residents near DeKalb. Smaller facility with generally shorter wait times.",
      icon: "ri-mail-line",
    },
    {
      id: "dkb-5",
      name: "Sandwich Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "22 N Eddy St",
      city: "Sandwich",
      state: "IL",
      zip: "60548",
      phone: "(815) 786-8505",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Sandwich, approximately 15 miles south of DeKalb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Sandwich and southern DeKalb County, also convenient for LaSalle County border residents. Historic downtown setting with generally shorter wait times.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 1.25 hour drive to Chicago", fpc: "No — ship from DeKalb" },
    { feature: "Time Commitment", agency: "2.5+ hour round trip — afternoon lost", fpc: "Minutes — ship from Lincoln Highway" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Practical for NIU", agency: "No — waste of study/campus time", fpc: "Yes — the smart fast solution" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "NIU Study Abroad Deadlines",
      description: "NIU students routinely discover expired or missing passports just weeks before semester abroad programs start. With Chicago over an hour away, students scramble for solutions during finals week. Our courier service is the fastest practical option — no need to miss class for a full-day Chicago trip.",
    },
    {
      icon: "ri-road-map-line",
      title: "Unnecessary Chicago Drive",
      description: "Many DeKalb County residents assume they can 'just drive to Chicago' for a passport emergency. At 1.25 hours each way plus downtown Chicago traffic, parking fees, and waiting time, this is a 3+ hour ordeal that most people — especially NIU students — simply cannot spare during the academic semester.",
    },
    {
      icon: "ri-passport-line",
      title: "Six-Month Validity Rule",
      description: "Many NIU students and DeKalb travelers don't realize that most European and Asian countries require 6 months of passport validity past the return date. A passport valid for 4 more months is effectively expired for study abroad programs in Germany, Spain, Japan, and most other destinations popular with NIU exchange programs.",
    },
    {
      icon: "ri-image-line",
      title: "NIU OneCard ≠ Passport Photo",
      description: "Northern Illinois University OneCards do not meet U.S. Department of State passport photo standards. The lighting, background, sizing, and expression requirements are completely different. Always use a dedicated passport photo service — UPS Store on Lincoln Highway is the closest reliable option.",
    },
    {
      icon: "ri-file-list-line",
      title: "Wrong Application Form",
      description: "Using DS-82 instead of DS-11 for first-time passports (or vice versa) is the #1 cause of rejection at DeKalb and Sycamore acceptance facilities. NIU freshmen getting their first passport for study abroad are especially prone to this mistake. Our document review catches this before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Study Abroad Visa vs Passport Confusion",
      description: "NIU study abroad students often confuse passport validity requirements with visa requirements. Your passport must be valid for the entire stay plus the 6-month buffer. Visa processing is entirely separate — start both processes early because neither can be rushed at the last minute during finals week.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from NIU campus, your dorm, or anywhere in DeKalb County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop at UPS Store on Lincoln Highway or any FedEx in DeKalb." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — experienced with NIU study abroad, faculty conference travel, and DeKalb County family needs." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — just over an hour away but you never make the drive." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your DeKalb address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in DeKalb, IL?", a: "Fast Passport Center offers emergency passport processing in DeKalb, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (1 hour 15 minutes east via I-88) — without you making the trip. For NIU students with study abroad deadlines, this is the fastest practical solution available." },
    { q: "Does DeKalb have a passport agency?", a: "No — DeKalb does not have a regional passport agency. The nearest facility is the Chicago Passport Agency approximately 1 hour 15 minutes east via I-88. Fast Passport Center's courier service is the most practical fast option for DeKalb County — especially for NIU students who need their passports for study abroad." },
    { q: "Do you serve Northern Illinois University students?", a: "Absolutely. Fast Passport Center serves NIU students, faculty, and staff. We understand semester abroad timelines, faculty conference travel, and international academic programs. Our 24–48 hour service is ideal for students who applied late to study abroad or received last-minute program acceptance." },
    { q: "What airport do DeKalb travelers use for international flights?", a: "Most DeKalb international travelers use Chicago O'Hare International Airport (ORD) — approximately 1 hour 15 minutes east via I-88. Chicago Midway (MDW) is approximately 1 hour 15 minutes southeast. Rockford International Airport (RFD) is about 45 minutes northwest and offers regional connections." },
    { q: "Can I get my child's passport expedited in DeKalb?", a: "Yes. Fast Passport Center expedites child passports in DeKalb for minors under 16. Both parents must appear or submit notarized consent. We guide DeKalb County families through the entire DS-11 process for minors." },
    { q: "Where can I get passport photos in DeKalb?", a: "The UPS Store on Lincoln Highway offers passport photos. Walgreens on Lincoln Highway and CVS in Sycamore also provide photo services. NIU's campus services may offer photos for students during the academic year. Photos must be 2x2 inches on a white background." },
    { q: "Is there really no other fast option in DeKalb County?", a: "Honestly — no. The Chicago Passport Agency is over an hour away and requires appointments booked weeks in advance for non-emergencies. For urgent international travel from DeKalb, Fast Passport Center's courier service is the only practical 24–48 hour option. It's why NIU students, faculty, and DeKalb County families rely on us." },
  ],
  photoLocations: [
    { name: "UPS Store — DeKalb", address: "2490 Sycamore Rd, DeKalb, IL 60115", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
    { name: "Walgreens — DeKalb", address: "1401 E Lincoln Hwy, DeKalb, IL 60115", hours: "Mon–Sun: 8AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS — Sycamore", address: "1830 DeKalb Ave, Sycamore, IL 60178", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "DeKalb Post Office", address: "600 E Lincoln Hwy, DeKalb, IL 60115", hours: "Mon–Fri: 9AM–4:30PM (photo services by appointment)", website: "https://tools.usps.com/find-location.htm" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — DeKalb", address: "1360 Oakwood Ave, DeKalb, IL 60115", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Located near NIU campus and I-88. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Rockford", address: "3720 E State St, Rockford, IL 61108", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Rockford area. REAL ID processing available. About 40 minutes northwest — good alternative if DeKalb DMV is booked out.", featured: false },
  ],
  airports: [
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 1 hour 15 minutes east via I-88",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub with extensive global connections. Most NIU study abroad students and DeKalb international travelers use ORD for direct international flights. About 1.25 hours from DeKalb.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: true,
    },
    {
      code: "RFD",
      name: "Chicago Rockford International Airport",
      distance: "Approximately 45 minutes northwest via I-39",
      address: "2 Airport Cir, Rockford, IL 61109",
      note: "Regional airport with Allegiant and seasonal international flights. Closer than Chicago airports and easier parking. Good for domestic connections and some vacation destinations.",
      flightUrl: "https://flyrfd.com/",
      flightLabel: "RFD Flight Info",
      featured: false,
    },
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "Approximately 1 hour 15 minutes southeast via I-88/I-355",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Major Southwest Airlines hub. Good for domestic connections and some international routes to Mexico and the Caribbean. Comparable drive time to O'Hare from DeKalb.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: false,
    },
  ],
};